import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiAddDenestImpcMapping = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'addNewDenestMappingDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, {
    denestImpc: payload.params.denestImpc,
    mrdImpc: payload.params.mrdImpc,
    mrdOperator: payload.params.mrdOperator,
    validFrom: moment(payload.params.validFrom).format('YYYY-MM-DD'),
    validTo: payload.params.validTo !== undefined ? moment(payload.params.validTo).format('YYYY-MM-DD') : null,
  });
};
